import {Action} from "@ngrx/store";
import {PageBillingActModel} from "@services/back-office/model/pageBillingActModel";
import { HttpErrorResponse } from "@angular/common/http";
import {BillingActModel} from "@services/back-office/model/billingActModel";
import {PaginationModel} from "@shared/models/pagination.model";
import {BillingContractSearchModel} from "@services/back-office/model/billingContractSearchModel";

export enum ActsActionTypes {
    LoadActs = '[Acts] Load Acts',
    LoadActsSuccess = '[Acts] Load Acts Success',
    LoadActsFailure = '[Acts] Load Acts Failure',
    EditAct = '[Act] Edit Acts',
    EditActSuccess = '[Act] Edit Acts Success',
    EditActFailure = '[Act] Edit Acts Failure',
    SignAct = '[Act] Sign Act',
    SignActSuccess = '[Act] Sign Act Success',
    SignActFailure = '[Act] Sign Act Failure',
    ToggleActSignedState = '[Act] Toggle Act Signed State',
    ToggleActSignedStateSuccess = '[Act] Toggle Act Signed State Success',
    ToggleActSignedStateFailure = '[Act] Toggle Act Signed State Failure',
    ChangePage = '[Acts] Change Page',
    SetInitialPagination = '[Acts] Set Initial Pagination',
    SetFilter = '[Acts] Set Filter',
    ClearFilter = '[Acts] Clear Filter',
    SetInitialState = '[Acts] Set Initial State',
}

export class LoadActs implements Action {
    readonly type = ActsActionTypes.LoadActs;
    constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadActsSuccess implements Action {
    readonly type = ActsActionTypes.LoadActsSuccess;
    constructor(public payload: PageBillingActModel) {}
}

export class LoadActsFailure implements Action {
    readonly type = ActsActionTypes.LoadActsFailure;
    constructor(public payload: HttpErrorResponse) {}
}

export class EditAct implements Action {
    readonly type = ActsActionTypes.EditAct;
    constructor(public payload: BillingActModel) {}
}

export class EditActSuccess implements Action {
    readonly type = ActsActionTypes.EditActSuccess;
    constructor(public payload: BillingActModel) {}
}

export class EditActFailure implements Action {
    readonly type = ActsActionTypes.EditActFailure;
    constructor(public payload: HttpErrorResponse) {}
}

export class SignAct implements Action {
    readonly type = ActsActionTypes.SignAct;
    constructor(public payload: string) {}
}

export class SignActSuccess implements Action {
    readonly type = ActsActionTypes.SignActSuccess;
    constructor(public payload: BillingActModel) {}
}

export class SignActFailure implements Action {
    readonly type = ActsActionTypes.SignActFailure;
    constructor(public payload: HttpErrorResponse) {}
}

export class ToggleActSignedState implements Action {
    readonly type = ActsActionTypes.ToggleActSignedState;
    constructor(public payload: { act: BillingActModel, signed: boolean }) {}
}

export class ToggleActSignedStateSuccess implements Action {
    readonly type = ActsActionTypes.ToggleActSignedStateSuccess;
    constructor(public payload: { act: BillingActModel, signed: boolean }) {}
}

export class ToggleActSignedStateFailure implements Action {
    readonly type = ActsActionTypes.ToggleActSignedStateFailure;
    constructor(public payload: HttpErrorResponse) {}
}

export class ChangePage implements Action {
    readonly type = ActsActionTypes.ChangePage;
    constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
    readonly type = ActsActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
    readonly type = ActsActionTypes.SetFilter;
    constructor(public payload: BillingContractSearchModel) { }
}

/** Clear Filter */
export class ClearFilter implements Action {
    readonly type = ActsActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
    readonly type = ActsActionTypes.SetInitialState;
}

export type ActsActions =
    | LoadActs
    | LoadActsSuccess
    | LoadActsFailure
    | EditAct
    | EditActSuccess
    | EditActFailure
    | SignAct
    | SignActSuccess
    | SignActFailure
    | ToggleActSignedState
    | ToggleActSignedStateSuccess
    | ToggleActSignedStateFailure
    | ChangePage
    | SetInitialPagination
    | SetFilter
    | ClearFilter
    | SetInitialState
    ;
